import { render, staticRenderFns } from "./Especializacao.vue?vue&type=template&id=e82a6dca"
import script from "./Especializacao.vue?vue&type=script&lang=js"
export * from "./Especializacao.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports